import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from '../../assets/icons';
import { IconSize } from '../../constant/IconSize.constant';
import { getISO8601TimezoneOffSetFromTimeZone } from '../../utils/Date.Util';
import { ColorType, Icon, Label, LabelType } from '../_ui';

export const TimezoneMessage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className='w-full flex flex-col basis-2/6 rounded p-2 gap-2 rounded-lg bg-grey1 items-start'>
      <Icon src={Info} size={IconSize.SIZE_16x16} />
      <Label
        text={t('timezone_msg')}
        type={LabelType.BODY4}
        color={ColorType.GREY6}
      />
      <Label
        text={
          Intl.DateTimeFormat().resolvedOptions().timeZone +
          getISO8601TimezoneOffSetFromTimeZone(
            Intl.DateTimeFormat().resolvedOptions().timeZone,
          )
        }
        type={LabelType.BODY4_BOLD}
        color={ColorType.GREY6}
      />
    </div>
  );
};
